import { Component, OnInit, OnDestroy, ChangeDetectorRef, Injector, inject, ViewEncapsulation } from '@angular/core';
import { AppConsts } from '../../../../../shared/AppConsts';


@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent  {

  appVersion : string = AppConsts.appVersion ;
 

  constructor(
 
  ) { 

    
    
  }
  

  

  
}
